export const localSetItem = (key: string, value: any) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const localGetItem = (key: string) => {
  const res = localStorage.getItem(key);

  if (res) {
    return JSON.parse(res);
  }
  return undefined;
};

export const localDeleteItem = (key: string) => {
  localStorage.removeItem(key);
};

export const sessionSetItem = (key: string, value: any) => {
  sessionStorage.setItem(key, JSON.stringify(value));
};

export const sessionRemoveItem = (key: string) => {
  sessionStorage.removeItem(key);
};

export const sessionGetItem = (key: string, remove = false) => {
  const res = sessionStorage.getItem(key);

  if (res) {
    try {
      return JSON.parse(res);
    } catch (error) {
      return res;
    } finally {
      if (remove) {
        sessionStorage.removeItem(key);
      }
    }
  }

  return undefined;
};
